const HeroSwiper = () => {
  document.addEventListener("DOMContentLoaded", () => {
      // Initialize Swiper
      const swiperEl = document.querySelector('.hero-carousel swiper-container');
      if (swiperEl) {
          const params = {
              injectStyles: [`
                  .swiper-pagination-bullet {
                      width: 20px;
                      height: 20px;
                      text-align: center;
                      line-height: 20px;
                      font-size: 12px;
                      color: #000;
                      opacity: 1;
                      background: rgba(0, 0, 0, 0.2);
                  }
                  .swiper-pagination-bullet-active {
                      color: #fff;
                      background: #007aff;
                  }
              `],
              pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
              },
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              }
          };

          Object.assign(swiperEl, params);
          swiperEl.initialize();
      }

      // Load YouTube API Once
      const loadYouTubeAPI = () => {
    return new Promise((resolve) => {
        if (window.YT && window.YT.Player) {
            resolve();
        } else {
            const script = document.createElement('script');
            script.src = "https://www.youtube.com/iframe_api";
            script.onload = () => {
                let checkYT = setInterval(() => {
                    if (window.YT && window.YT.Player) {
                        clearInterval(checkYT);
                        resolve();
                    }
                }, 100); // Check every 100ms until YT API is fully loaded
            };
            document.body.appendChild(script);
        }
    });
};


      // Initialize YouTube Background Videos
      const initYouTubeVideos = () => {
          const slides = document.querySelectorAll('swiper-slide');
          const slideVideo = document.querySelectorAll('swiper-slide .slide-video-container');

          if (!slideVideo.length > 0) return;

          slides.forEach((slide) => {
              const videoId = slide.getAttribute('data-video-id');
              const videoWrapper = slide.querySelector('.slide-video-container');

              if (videoId) {
                  const videoContainer = document.createElement('div');
                  videoContainer.className = 'video-container';
                  videoContainer.id = `youtube-player-${videoId}`;

                  // Insert the video container before the fallback image
                  const img = slide.querySelector('img');
                  if (img) {
                    img.style.display = 'none'; // Hide the fallback image
                    videoWrapper.appendChild(videoContainer, img);
                  }

                  // Initialize YouTube Player after API is ready
                  new YT.Player(videoContainer.id, {
                      videoId: videoId,
                      playerVars: {
                          autoplay: 1,
                          mute: 1,
                          loop: 1,
                          playlist: videoId, // Required for seamless looping
                          controls: 0,
                          modestbranding: 1,
                          rel: 0,
                          showinfo: 0,
                          iv_load_policy: 3, // Disable annotations
                          disablekb: 1, // Disable keyboard controls
                      },
                      events: {
                          onReady: (event) => {
                              event.target.playVideo();
                          },
                      },
                  });
              } else {
                //ALLOW VIDEO TO PLAY FOR HTML5 VIDEO EXAMPLE
                // videoWrapper.style.display = 'none'; // Hide the video container if no video ID is provided
              }
          });
      };

      // Load YouTube API and Initialize Videos
      loadYouTubeAPI().then(() => {
          if (window.YT && window.YT.Player) {
              initYouTubeVideos();
          }
      });
  });
};

export default HeroSwiper;






